function BackIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="3rem"
      height="3rem"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 12H6"></path>
      <path d="M11 19L5 12L11 5"></path>
    </svg>
  );
}

export default BackIcon;
